import {
  SET_VALIDATION_RESULTS,
  SET_FORM_VALUE,
  validationActions,
  setFormValueAction,
  testActions,
  DO_VALIDATE,
} from '../Actions';
import * as _ from 'lodash';
import { validateStepsByValidationResults } from './validation.helpers';
import { ValidationState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { FormCommonGlobals } from 'sos-common/js/commonTypes/FormBaseStore.types';

type PossibleActions = validationActions | setFormValueAction | testActions;

const initialValidationState = {
  validationResults: [],
  fullValidationResults: [],
  stepValidationMap: {},
  touchedFields: [],
  isBootValues: true,
} as ValidationState;

function setValidationResultsAndValidate(
  state: ValidationState,
  validationResults: ValidationResult[],
  hasHitSummary: boolean
): ValidationState {
  const newState = { ...state, validationResults, fullValidationResults: validationResults };
  return validateStepsByValidationResults(newState, hasHitSummary);
}

function addTouchedFieldAndClearByFields(state: ValidationState, field: FormField<any> | Array<FormField<any>>) {
  if (Array.isArray(field)) {
    let result = state;
    field.forEach((element) => {
      result = addTouchedFieldAndClearByFieldName(result, element);
    });
    return result;
  } else {
    return addTouchedFieldAndClearByFieldName(state, field);
  }
}
function addTouchedFieldAndClearByFieldName(state: ValidationState, field: FormField<any>) {
  var errorsClearedState = clearErrorByFieldName(state, field);
  if (field.isTouched && errorsClearedState.touchedFields.indexOf(field.fieldName) < 0) {
    var newTouchedFields = errorsClearedState.touchedFields.slice();
    newTouchedFields.push(field.fieldName);
    errorsClearedState.touchedFields = newTouchedFields;
  }
  return errorsClearedState;
}

function clearErrorByFieldName(state: ValidationState, field: FormField<any>) {
  const index = state.validationResults.findIndex((v) => {
    const fieldName = field.fieldName.replace('CurrentResearchOrder.', '');
    return v.FieldName === field.fieldName;
  });
  if (index > -1) {
    state.validationResults.splice(index, 1);
    const clearedValidationResults = state.validationResults.slice();
    return { ...state, validationResults: clearedValidationResults };
  }
  return state;
}

export function validationResults(
  state: ValidationState = initialValidationState,
  action: PossibleActions,
  globals: FormCommonGlobals
): ValidationState {
  switch (action.type) {
    case SET_VALIDATION_RESULTS:
      return setValidationResultsAndValidate(state, action.payload, globals.hasHitSummary);
    case SET_FORM_VALUE:
      return addTouchedFieldAndClearByFields(state, action.payload);
    case DO_VALIDATE:
      return validateStepsByValidationResults(state, globals.hasHitSummary);
    default:
      return state;
  }
}
